import { object, collection, string } from '@gogame/schemas';

export const DIMENSION_AFFILIATE = 'Affiliate';
export const DIMENSION_CAMPAIGN = 'Campaign';

const drillItemSchema = object({
  type: string().default(''),
  id: string().nullable().default(''),
});

export const drillPathSchema = collection(drillItemSchema).default([
  {
    type: DIMENSION_AFFILIATE,
    id: '',
  },
]);

export const nextDimensionSchema = string().default(DIMENSION_CAMPAIGN);
